import { createClient } from "@sanity/client";

export default createClient({
    projectId: "3kscc6q0",
    dataset: "production",
    useCdn: true,
    apiVersion: "2021-03-25",
});